'use strict';

/** @type {import('./isNaN')} */
module.exports = Number.isNaN || function isNaN(a) {
	return a !== a;
};



//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/emr-webapp/~/math-intrinsics/isNaN.js
// module id = ../../../../math-intrinsics/isNaN.js
// module chunks = 5